import { useMutation } from "@tanstack/react-query";
import { hsmApi } from "../../api";
import { CreateRequireSignPayload } from "../../types";

export const useCreateRequireSign = () => {
  return useMutation({
    mutationFn: (body: CreateRequireSignPayload) => hsmApi.createRequireSign(body),
  });
};
